import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './PaginationDots.styled';

/**
 * Indicator for the number of slides and selected slide in a Carousel
 */
const PaginationDots = ({ count, selectedIndex, ...rest }) => (
  <Styled.PaginationDots {...rest} data-testid="paginationDots">
    {[...Array(count)].map((_value, index) => (
      <Styled.Dot key={index} selected={index === selectedIndex} />
    ))}
  </Styled.PaginationDots>
);

PaginationDots.propTypes = {
  /**
   * number of slides
   */
  count: PropTypes.number,
  /**
   * index of selected slide
   */
  selectedIndex: PropTypes.number
};

PaginationDots.defaultProps = {
  count: 0,
  selectedIndex: 0
};

export default PaginationDots;
